import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";

const STRATEGIES = [
  {
    n: "01",
    slug: "industrial-credit",
    title: "Industrial Credit",
    body:
      "Senior-secured and unitranche financings to lower-mid-market industrial operators with tangible collateral and cash-flow durability.",
  },
  {
    n: "02",
    slug: "bridge-capital",
    title: "Bridge Capital",
    body:
      "Time-sensitive financings ahead of refinancing, capital events or recapitalisations — structured with covenants, collateral and clear exits.",
  },
  {
    n: "03",
    slug: "opportunistic-equity",
    title: "Opportunistic Industrial Equity",
    body:
      "Control and influence equity positions in asset-rich industrial businesses with operational improvement or value-realisation pathways.",
  },
  {
    n: "04",
    slug: "structured-solutions",
    title: "Structured Capital Solutions",
    body:
      "Bespoke preferred, hybrid and structured instruments structured with a focus on downside protection and risk-adjusted outcomes.",
  },
];

const Strategies = () => {
  return (
    <section
      id="strategies"
      data-testid={LANDING.strategies}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)]"
      style={{ background: "var(--kr-bg-2)" }}
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16 items-end mb-20">
          <div className="lg:col-span-8">
            <SectionHeading
              index="03"
              label="Investment Strategies"
              title={
                <>
                  Four mandates.{" "}
                  <span className="italic text-[var(--kr-gold)]">
                    One underwriting
                  </span>{" "}
                  standard.
                </>
              }
            />
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <Link
              to="/strategies"
              data-testid={LANDING.viewAllStrategies}
              className="kr-link font-mono-label text-[11px]"
            >
              View All Strategies →
            </Link>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-[var(--kr-line)]">
          {STRATEGIES.map((s, idx) => (
            <Link
              key={s.n}
              to={`/strategies/${s.slug}`}
              data-testid={`${LANDING.strategyCardPrefix}${s.n}`}
              className={`kr-strategy-card relative p-10 lg:p-12 border-b border-[var(--kr-line)] block group hover:bg-[rgba(201,169,110,0.03)] transition-colors duration-500 ${
                idx < STRATEGIES.length - 1
                  ? "lg:border-r border-[var(--kr-line)]"
                  : ""
              } ${
                idx % 2 === 0
                  ? "sm:border-r sm:border-[var(--kr-line)] lg:border-r"
                  : ""
              }`}
            >
              <div className="flex items-baseline justify-between mb-12">
                <span className="font-mono-label text-[10px] text-[var(--kr-gold)]">
                  {s.n} / 04
                </span>
                <span
                  aria-hidden
                  className="font-serif-display italic text-[var(--kr-text-dim)] text-3xl group-hover:text-[var(--kr-gold)] transition-colors"
                >
                  →
                </span>
              </div>
              <h3 className="font-serif-display text-[1.7rem] leading-[1.15] text-[var(--kr-text)] mb-6 min-h-[3.2em] group-hover:text-[var(--kr-gold)] transition-colors">
                {s.title}
              </h3>
              <p className="text-[var(--kr-text-muted)] text-[14.5px] leading-[1.75]">
                {s.body}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strategies;
